import { inject, Injectable } from '@angular/core';
import { BaseService } from '@shared/core';
import { Observable } from 'rxjs';
import { IGateItem, IGateParams, IGatePayload } from '@pkp-g/core';

@Injectable({
  providedIn: 'root',
})
export class GatesApiService {
  private http = inject(BaseService);
  apiUrl = 'v1/gates';

  getAllGates(filter?: IGateParams): Observable<IGateItem[]> {
    return this.http.get(this.apiUrl, filter);
  }

  setGate(payload: IGatePayload): Observable<unknown> {
    return this.http.post(this.apiUrl, payload);
  }

  getGateById(id: string): Observable<IGateItem> {
    return this.http.get(this.apiUrl + '/' + id);
  }

  updateGateById(id: string, payload: IGatePayload): Observable<unknown> {
    return this.http.put(this.apiUrl + '/' + id, payload);
  }

  deleteGate(id: string): Observable<unknown> {
    return this.http.delete(this.apiUrl + '/' + id);
  }
}
